import styled from 'styled-components/macro'
import React, { Fragment, useState } from 'react'
import { timeInterval } from 'utilities/utility.timeInterval'
import { getFocus, useGet } from 'state/jotai'
import { active_project } from 'state/store.global'
import { _project } from 'state/store.projects'
import { getIsoData } from 'state/jotai.isometryDataHooks'
import { _seasons_isometry } from 'state/store.season'
import { useBreak } from 'hooks/useBreak'

export const SeasonSliderThumb = ({props, index}, state) => {
  const fill = clr.buttons

  return (
    <StyledThumb key={index} {...props}>
      <SVG index={index}></SVG>
    </StyledThumb>
  )
}

const SVG = ({ index, children}) => {
  const { pin, pid }        = useGet(active_project);
  const activeIsometryFrame = getIsoData("activeframe");
  const season     = getFocus(_seasons_isometry, 'season_type');
  const seasonType = season?.[pin]?.[pid]?.[activeIsometryFrame]?.type;
  const isMobile = useBreak('md_dn')

  const seasonTime = {
    "fall": "07:41",
    "summer": "04:47",
    "winter": "08.29",
    "spring": "06.03"
  }

  const [cursor, setCursor] = useState('grab')

  const endTime = timeInterval(seasonTime[seasonType], 1, index, 'minutes', 'HH.mm'); 
  
  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  const svgPos = { 
    overflow: 'visible', 
    width: '100%',
    height: '100%',
    cursor:cursor
  }

  return (
    <>
       <div style={{display: "flex", alignItems: "start", position: "absolute", top: isMobile ? "-56px" : "-42px", left: "-36px", justifyContent: "center", flexDirection: "column", color: "#000"}}>
          <div style={{ fontWeight: "500", fontSize: "14px", lineHeight: "18px", display: "flex", flexDirection: 'column', whiteSpace: 'nowrap' }}>
              <div style={{ fontWeight: "600" }}>{buttonsLabel?.filter( btn => btn.UILabelProperty === 'Tidspunkt')[0]?.Label}:</div>
              <div style={{ textAlign: "center" }}>{endTime}</div>
          </div>
      </div> 
      {/* <Svg 
        viewBox={`0 0 100 100`}
        onMouseDown={()=>setCursor('grabbing')}
        onMouseUp={()=>setCursor('grab')}
        onMouseLeave={()=>setCursor('grab')}
        onMouseEnter={()=>setCursor('grab')}
        style={{cursor:cursor}}
        clr={clr}
        >
        { children }
      </Svg> */}
        <StyledThumb>
      <div style={thumbBackground} onMouseDown={()=>setCursor('grabbing')}
        onMouseUp={()=>setCursor('grab')}
        onMouseLeave={()=>setCursor('grab')}
        onMouseEnter={()=>setCursor('grab')}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='3 3 42 42'
          style={svgPos}
        >
          <defs>
            <clipPath id='ab'>
              <path fill='none' d='M0 0h53.823v53.822H0z'/>
            </clipPath>
          </defs>
          <g clipPath='url(#ab)' transform="translate(-3.0634689,-1.5639996)">
            <path
              fill={clr.primary}
              d='
                m27.195 1.564
                a24.127 24.127 0 1 0 12.06 3.233 24.128 24.128 0 0 0-12.06-3.233
                m-8.12 28.079
                a1.725 1.725 0 1 1-2.43 2.448l-5.171-5.167
                a1.725 1.725 0 0 1-.009-2.438l.009-.009 5.171-5.171
                a1.725 1.725 0 1 1 2.43 2.448l-3.947 3.937Z
                m8.119-.5
                a3.446 3.446 0 1 1 2.438-1.009 3.446 3.446 0 0 1-2.437 1.008
                m15.72-2.218-5.171 5.167
                a1.725 1.725 0 0 1-2.43-2.448l3.945-3.952-3.947-3.947
                a1.725 1.725 0 1 1 2.43-2.448l5.171 5.171
                a1.724 1.724 0 0 1 .009 2.438l-.009.009z'
            />
          </g>
        </svg>
      </div>
    </StyledThumb>
    </>

  )
}

const thumbBackground = {
  backgroundColor: '#ffffff',
  borderRadius: '50%',
  width: '100%', 
  height: '100%',
}

const StyledThumb = styled.div`
  position: absolute;
  height: 35px;
  width: 35px;
  text-align: center;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
`
